import { ReactNode } from 'react';
import { Spin, SpinProps } from '@ssar-app/uikit';

interface LoadingProps extends SpinProps {
  message?: ReactNode;
  children?: ReactNode;
}

export const Loading = (props: LoadingProps) => {
  return (
    <Spin
      spinning
      tip={props.message || props.children || 'Loading required data...'}
      tipProps={{ fontSize: 'xl' }}
    />
  );
};
